// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListEmployeesForSearchPopupQueryVariables = Types.Exact<{
  pageNumber: Types.Scalars['Int']['input'];
  pageSize: Types.Scalars['Int']['input'];
  filter: Types.InputMaybe<Types.ListEmployeesFilterInput>;
  sort: Types.InputMaybe<Array<Types.ListEmployeesSortInput> | Types.ListEmployeesSortInput>;
}>;

export type ListEmployeesForSearchPopupQuery = { __typename?: 'Query' } & {
  listEmployees: { __typename?: 'ListEmployees' } & Pick<Types.ListEmployees, 'totalCount'> & {
      items: Array<
        { __typename?: 'Employee' } & Pick<Types.Employee, 'id' | 'status'> & {
            generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
              Types.EmployeeGeneralInformation,
              'preferredFullName' | 'legalFullName' | 'hiredDate'
            >;
            currentMainContract: Types.Maybe<
              { __typename?: 'EmployeeContract' } & {
                company: { __typename?: 'Company' } & Pick<Types.Company, 'countryId' | 'name'> & {
                    country: { __typename?: 'Country' } & Pick<Types.Country, 'name'>;
                  };
              }
            >;
            currentPosition: Types.Maybe<
              { __typename?: 'EmployeeJobHistory' } & Pick<Types.EmployeeJobHistory, 'level' | 'jobTitle'> & {
                  businessUnit: { __typename?: 'BusinessUnit' } & Pick<Types.BusinessUnit, 'name'>;
                  department: { __typename?: 'Department' } & Pick<Types.Department, 'name'>;
                  job: { __typename?: 'Job' } & Pick<Types.Job, 'name'>;
                }
            >;
          }
      >;
    };
};

export const ListEmployeesForSearchPopupDocument = /*#__PURE__*/ gql`
    query listEmployeesForSearchPopup($pageNumber: Int!, $pageSize: Int!, $filter: ListEmployeesFilterInput, $sort: [ListEmployeesSortInput!]) {
  listEmployees(
    pageNumber: $pageNumber
    pageSize: $pageSize
    filter: $filter
    sort: $sort
  ) {
    items {
      id
      status
      generalInformation {
        preferredFullName
        legalFullName
        hiredDate
      }
      currentMainContract {
        company {
          countryId
          country {
            name
          }
          name
        }
      }
      currentPosition {
        level
        businessUnit {
          name
        }
        department {
          name
        }
        job {
          name
        }
        jobTitle
      }
    }
    totalCount
  }
}
    `;

/**
 * __useListEmployeesForSearchPopupQuery__
 *
 * To run a query within a React component, call `useListEmployeesForSearchPopupQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEmployeesForSearchPopupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEmployeesForSearchPopupQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useListEmployeesForSearchPopupQuery(
  baseOptions: Apollo.QueryHookOptions<ListEmployeesForSearchPopupQuery, ListEmployeesForSearchPopupQueryVariables> &
    ({ variables: ListEmployeesForSearchPopupQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListEmployeesForSearchPopupQuery, ListEmployeesForSearchPopupQueryVariables>(
    ListEmployeesForSearchPopupDocument,
    options,
  );
}
export function useListEmployeesForSearchPopupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListEmployeesForSearchPopupQuery,
    ListEmployeesForSearchPopupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListEmployeesForSearchPopupQuery, ListEmployeesForSearchPopupQueryVariables>(
    ListEmployeesForSearchPopupDocument,
    options,
  );
}
// @ts-expect-error
export function useListEmployeesForSearchPopupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListEmployeesForSearchPopupQuery,
    ListEmployeesForSearchPopupQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListEmployeesForSearchPopupQuery, ListEmployeesForSearchPopupQueryVariables>;
export function useListEmployeesForSearchPopupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListEmployeesForSearchPopupQuery, ListEmployeesForSearchPopupQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ListEmployeesForSearchPopupQuery | undefined,
  ListEmployeesForSearchPopupQueryVariables
>;
export function useListEmployeesForSearchPopupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListEmployeesForSearchPopupQuery, ListEmployeesForSearchPopupQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListEmployeesForSearchPopupQuery, ListEmployeesForSearchPopupQueryVariables>(
    ListEmployeesForSearchPopupDocument,
    options,
  );
}
export type ListEmployeesForSearchPopupQueryHookResult = ReturnType<typeof useListEmployeesForSearchPopupQuery>;
export type ListEmployeesForSearchPopupLazyQueryHookResult = ReturnType<typeof useListEmployeesForSearchPopupLazyQuery>;
export type ListEmployeesForSearchPopupSuspenseQueryHookResult = ReturnType<
  typeof useListEmployeesForSearchPopupSuspenseQuery
>;
